import { useMutation, useQuery } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ApiErrorResponse } from '../types.ts'

import { apiService } from './root.ts'
import { MessageResponse, MessageWithSuccessResponse } from './services.types.ts'

export const LOGIN_ROOT = '/login'
export const LK_ENDPOINTS = {
  login: LOGIN_ROOT,
  loginVerify: `${LOGIN_ROOT}/verify`,
  logout: '/logout',
  resendCode: `${LOGIN_ROOT}/resendingCode`,
  resetPassword: `${LOGIN_ROOT}/reset-password`,
  changePassword: `${LOGIN_ROOT}/change-password`,
}

export interface LoginVerifyResponse {
  token: string
}

export interface LoginResponse extends MessageResponse {
  isChangePassword?: boolean
}

export interface ChangePasswordParams {
  login: string
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export const useLoginMutation = () =>
  useMutation<AxiosResponse<LoginResponse>, AxiosError<ApiErrorResponse>, { password: string; login: string }, unknown>(
    {
      mutationFn: (bodyParams) => apiService.post<LoginResponse>(LK_ENDPOINTS.login, { bodyParams }),
    }
  )

export const useLogoutQuery = () =>
  useQuery({
    queryKey: ['logout'],
    enabled: false,
    queryFn: () => apiService.get(LK_ENDPOINTS.logout),
  })

export const useVerifyLoginMutation = (login: string) =>
  useMutation<AxiosResponse<LoginVerifyResponse>, AxiosError<ApiErrorResponse>, { code: string }, unknown>({
    mutationFn: ({ code }) =>
      apiService.post<LoginVerifyResponse>(LK_ENDPOINTS.loginVerify, { bodyParams: { login, code } }),
  })

export const useResetPasswordMutation = () =>
  useMutation<AxiosResponse<MessageResponse>, AxiosError<ApiErrorResponse>, { login: string }, unknown>({
    mutationFn: (bodyParams) => apiService.post<MessageResponse>(LK_ENDPOINTS.resetPassword, { bodyParams }),
  })

export const useChangePasswordMutation = () =>
  useMutation<AxiosResponse<MessageWithSuccessResponse>, AxiosError<ApiErrorResponse>, ChangePasswordParams, unknown>({
    mutationFn: (bodyParams) =>
      apiService.post<MessageWithSuccessResponse>(LK_ENDPOINTS.changePassword, { bodyParams }),
  })
